import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import styled from "styled-components";

import { lighten, darken } from "../actions";

import Container from "../containers/container";
import Hero from "../containers/hero"
import About from "../containers/about";

import Button from "../components/Button";
import ProjectCard from "../components/ProjectCard"

// import { Left, Right } from "../containers/backgrounds";

import email from "../images/email.svg";
import github from "../images/github.svg";
import linkedin from "../images/linkedin.svg";
import cms from "../images/cms.png";
import bank from "../images/bank.png";
import eyes from "../images/eyes.png";

const Work = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 80px;
  width: 100%;
  margin-bottom: 96px;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 1024px) {
    margin: 40px auto;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;

  & > * {
    margin-right: 16px;
  }

  @media (max-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: 248px;
    a {
      margin-bottom: 10px;
    }
  }
  @media (max-width: 425px) {
    display: grid;
    grid-template-columns: 1fr;
    max-width: 248px;
    a {
      margin-bottom: 10px;
    }
  }
`;

const Design = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <>
      <a className="anchor" id="about"></a>
      <Container>
        <Hero>
          <About>
            <h1>digital design</h1>
            <ButtonRow>
              <a href="mailto:stephen.sjbrown@gmail.com">
                <Button>
                  email <img src={email} />
                </Button>
              </a>
              <a
                target="_blank"
                href="https://www.linkedin.com/in/stephensjbrown/"
              >
                <Button>
                  linkedin <img src={linkedin} />
                </Button>
              </a>
              <a target="_blank" href="https://github.com/StephenSJBrown/">
                <Button>
                  github <img src={github} />
                </Button>
              </a>
              {/* <a target="_blank" href={cv}>
              <Button>
                cv <img src={doc} />
              </Button>
            </a> */}
            </ButtonRow>
          </About>
        </Hero>
        <a className="anchor" id="work"></a>
        <Work>
          <h2>selected work</h2>
          <ProjectCard as="div" style={{ cursor: 'default', pointerEvents: 'none' }}>
            <div className="image-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--panel-bg)' }}>
              <img src="https://raw.githubusercontent.com/simple-icons/simple-icons/develop/icons/google.svg" alt="Google Logo" style={{ width: '80px', height: '80px', objectFit: 'contain', filter: 'grayscale(100%) contrast(0.5)', opacity: 0.3 }} />
            </div>
            <div>
              <div className="project-header">
                <h3 className="project-title">Google</h3>
                <h4 style={{ color: 'var(--text-color)', opacity: 0.5 }}>Private / Releasing Soon</h4>
              </div>
              <p>Upcoming Google project. This work is currently private and will be shown once publically launched.</p>
            </div>
          </ProjectCard>

          <ProjectCard href="/design/cms">
            <div className="image-wrapper">
              <img src={cms} alt="Child Maintenance Service" />
            </div>
            <div>
              <div className="project-header">
                <h3 className="project-title">Child Maintenance Service</h3>
                <h4>UX/UI DESIGN</h4>
              </div>
              <p>I joined a team to help reimagine this online government service.</p>
            </div>
          </ProjectCard>
          
          <ProjectCard href="/design/bank">
            <div className="image-wrapper">
              <img src={bank} alt="Bank Prize Draw" />
            </div>
            <div>
              <div className="project-header">
                <h3 className="project-title">Bank Prize Draw</h3>
                <h4>USER RESEARCH</h4>
              </div>
              <p>I led research to inform the design of a loyalty prize draw for a UK bank.</p>
            </div>
          </ProjectCard>

          <ProjectCard href="/design/eyescan">
            <div className="image-wrapper">
              <img src={eyes} alt="EyeScan" />
            </div>
            <div>
              <div className="project-header">
                <h3 className="project-title">EyeScan</h3>
                <h4>UI DESIGN & DEVELOPMENT</h4>
              </div>
              <p>I designed and developed this proof of concept for an ophthalmology diagnostic tool.</p>
            </div>
          </ProjectCard>
        </Work>
      </Container>
    </>
  );
};

export default Design;
